import { render, staticRenderFns } from "./IndustryVideo.vue?vue&type=template&id=e10d40c8&"
import script from "./IndustryVideo.vue?vue&type=script&lang=js&"
export * from "./IndustryVideo.vue?vue&type=script&lang=js&"
import style0 from "./IndustryVideo.vue?vue&type=style&index=0&id=e10d40c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports